(function() {
  customElements.whenDefined('cart-drawer-items').then(() => {
    const CartDrawerItemsClass = customElements.get('cart-drawer-items');
    if (!CartDrawerItemsClass) return;

    const original = CartDrawerItemsClass.prototype.updateQuantity;

    CartDrawerItemsClass.prototype.updateQuantity = async function(line, quantity, variantId) {
      await original.call(this, line, quantity, variantId);
      this.refreshCartDrawer();
    };

    CartDrawerItemsClass.prototype.refreshCartDrawer = function() {
      // First get real cart state
      fetch('/cart.js')
        .then(r => r.json())
        .then(cartData => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            if (cartData.item_count === 0) {
              cartDrawer.classList.add('is-empty');
            } else {
              cartDrawer.classList.remove('is-empty');
            }
          }

          // Fetch drawer section
          const drawerFetch = fetch('/cart?section_id=cart-drawer')
            .then(r => r.text())
            .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newDrawer = doc.querySelector('#CartDrawer');
              const currentDrawer = document.querySelector('#CartDrawer');
              if (newDrawer && currentDrawer) {
                currentDrawer.innerHTML = newDrawer.innerHTML;
              }
            });

          // Fetch bubble section separately
          const bubbleFetch = fetch('/cart?section_id=cart-icon-bubble')
            .then(r => r.text())
            .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newBubbleSection = doc.querySelector('.shopify-section');
              const currentBubble = document.getElementById('cart-icon-bubble');
              if (currentBubble && newBubbleSection) {
                currentBubble.innerHTML = newBubbleSection.innerHTML;
              }
            });

          return Promise.all([drawerFetch, bubbleFetch]);
        })
        .catch(err => console.error('Cart drawer refresh failed:', err));
    };
  });
})();